import { useHistory } from "react-router-dom";
import { useReturnUrl } from "shared-hooks";
import { IAddress } from "services/api/BillingApi/BillingApi";
import checkIsValidAddress from "helpers/checkIsValidAddress";
import applicationMap from "services/applicationMap";
import { useUpdateDetailsPopUp } from "app/hooks/useUpdateDetailsPopUp";

export function useValidAddressOrRedirectAction({
  address,
  redirect,
  returnPath,
}: {
  address: IAddress | undefined;
  redirect: string;
  returnPath: string;
}): () => void {
  const history = useHistory();
  const { redirectWithReturnUrl } = useReturnUrl();

  const isValidAddress = checkIsValidAddress(address);

  const handleRedirectUser = () => {
    if (!isValidAddress) {
      return redirectWithReturnUrl(
        applicationMap.routes.settingsMyDetails(),
        returnPath
      );
    }

    history.push(redirect);
  };

  const { showUpdateDetailsPopUp } = useUpdateDetailsPopUp(handleRedirectUser);

  return () => {
    if (isValidAddress) return handleRedirectUser();

    return showUpdateDetailsPopUp();
  };
}
